import { camelizeKeys } from 'humps';
import { ihubPost } from '@namespace/helpers';

export const setShopOrder = (props) =>
  ihubPost('/ihub/api/v1/shop/order/place', props).then(camelizeKeys);
